module.exports = __webpack_public_path__ + "atomic/_patterns/organisms/paragraph-text-media/_paragraph-text-media.twig";